import React, { useState } from "react";
import { dataHandlers } from "../../utils/objectHandlers";
import { useSelector,useDispatch } from "react-redux";
import { addUploadedImages } from "../../Store/reducers/fabricCanvasSlice";
import { useEffect } from "react";
import { uploadImages } from "../../Store/reducers/uploadSlice";

const Upload = () => {
  const dispatch = useDispatch();
  const fabricCanvas = useSelector((state) => state.fabricCanvas.fabricCanvas);  
  const { uploadedImages, loading, error } = useSelector((s) => s.uploads)
  const [base64Map, setBase64Map] = useState({});

  async function getBase64FromUrl(url) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error("Failed to read blob as data URL"));
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  useEffect(() => {
    uploadedImages.forEach((imgObj) => {
      const url = imgObj.url;
      if (!base64Map[url]) {
        getBase64FromUrl(url)
          .then((b64) => {
            setBase64Map((m) => ({ ...m, [url]: b64 }));
          })
          .catch(() => {
           
          });
      }
    });
  }, [uploadedImages, base64Map]);


  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files)
    if (files.length) dispatch(uploadImages(files))
  }

   const handleDragStart = (e, imgObj) => {
    const isSVGFile =
      (imgObj.file && imgObj.file.type === "image/svg+xml") ||
      (!imgObj.file && imgObj.url.toLowerCase().endsWith(".svg"));

    if (isSVGFile) {
      e.dataTransfer.setData("svg", imgObj.url);
    } else {
     
      const payload = base64Map[imgObj.url] || imgObj.url;
      e.dataTransfer.setData("image", payload);
    }
  };

  const handleAddImage = async (imgObj) => {
    if (!fabricCanvas) return;
    const centerX = fabricCanvas.getWidth() / 2;
    const centerY = fabricCanvas.getHeight() / 2;

    const isSVGFile =
      (imgObj.file && imgObj.file.type === "image/svg+xml") ||
      (!imgObj.file && imgObj.url.toLowerCase().endsWith(".svg"));

    if (isSVGFile) {
      if (imgObj.file) {
        dataHandlers.svgFile(imgObj.file, fabricCanvas, { left: centerX, top: centerY });
      } else {
        dataHandlers.svg(imgObj.url, fabricCanvas, { left: centerX, top: centerY });
      }
    } else {
      
      const payload = base64Map[imgObj.url] || imgObj.url;
      dataHandlers.image(payload, fabricCanvas, { left: centerX, top: centerY });
    }
  };

  return (
    <div className="w-full">
      <div className="flex p-2 items-center justify-center">
        <label
          htmlFor="file-upload"
          className="font-montserrat font-semibold bg-black w-[241px] h-[32px] rounded-lg text-white text-[12px] flex items-center justify-center cursor-pointer"
        >
          Upload SVG, PNG, JPG
        </label>
        <input
          id="file-upload"
          type="file"
          accept=".svg,.png,.jpg,.jpeg"
          multiple
          onChange={handleFileUpload}
          className="hidden"
        />
      </div>

      <div className="h-[1px] w-full bg-gray-200 my-4" />

      <div className="w-full h-[435px] p-3 rounded-lg overflow-y-scroll custom-scrollbar">
        <div className="font-semibold text-black mb-2">Recently Uploaded</div>
        <div className="grid grid-cols-2 gap-2 cursor-pointer w-full">
          {uploadedImages.map((imgObj, index) => (
            <div
              key={index}
              className="flex justify-center"
              draggable
              onDragStart={(e) => handleDragStart(e, imgObj)}
              onClick={() => handleAddImage(imgObj)}
            >
              <img
                src={imgObj.url}
                alt={`Recently uploaded image ${index + 1}`}
                className="w-[107px] h-[104px] object-cover rounded-lg border-2 border-black"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Upload;
